import { render, staticRenderFns } from "./orgitem.vue?vue&type=template&id=1d5137ce&scoped=true&"
import script from "./orgitem.vue?vue&type=script&lang=js&"
export * from "./orgitem.vue?vue&type=script&lang=js&"
import style0 from "./orgitem.vue?vue&type=style&index=0&id=1d5137ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5137ce",
  null
  
)

export default component.exports